var map = {
	"./cam-1.webp": 321,
	"./cam-10.webp": 567,
	"./cam-2.webp": 52,
	"./cam-3.webp": 935,
	"./cam-4.webp": 282,
	"./cam-5.webp": 997,
	"./cam-6.webp": 168,
	"./cam-7.webp": 931,
	"./cam-8.webp": 758,
	"./cam-9.webp": 785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 348;